import PropTypes from "prop-types";
import React, { useState } from "react";
import { LOADING_STATES, useRothko } from "web/react/hooks/use-rothko/use-rothko";
import LoadingSpinner from "web/react/components/loading-spinner/loading-spinner";
import styles from "./related-search-product-images.css";

function RelatedSearchProductImages({ feedUrl }) {
    const ENDPOINT = "modules/related_search_products";

    const [rothkoOptions] = useState({ feed_url: feedUrl });
    const { data, loadingState } = useRothko(ENDPOINT, rothkoOptions);

    return (
        <div className={styles.relatedSearchImages}>
            {loadingState == LOADING_STATES.COMPLETE &&
                data.products.map((product) => {
                    return (
                        <img
                            key={product.image_url}
                            src={product.image_url}
                            alt={product.alt_text}
                            className={styles.relatedSearchImage}
                        />
                    );
                })}
            {loadingState == LOADING_STATES.PENDING && <LoadingSpinner />}
        </div>
    );
}

RelatedSearchProductImages.propTypes = {
    feedUrl: PropTypes.string.isRequired,
};

export default RelatedSearchProductImages;
